import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useAuthentication from './useAuthentication';

function usePageTracking(props) {
  const location = useLocation();
  const { isAuthenticated, account } = useAuthentication();

  function onPageLoad() {
    if (window.dataLayer) {
      const authenticatedSource = account()?.idTokenClaims.authenticationSource || null;
      const socialIssuer = account()?.idTokenClaims.socialIssuer || null;
      const authenticatedEvent = account()?.idTokenClaims.event || null;
      const authenticatedError = account()?.idTokenClaims.authenticationError || null;

      // Create custom page view event.
      const pageView = {
        event: 'reactpageview',
        customPageTitle: window.location.pathname,
        customPagePath: window.location.href,
        authenticated: isAuthenticated(),
        authenticatedMethod: isAuthenticated() ? `${authenticatedSource} ${socialIssuer || 'email'}` : null,
        authenticatedEvent: isAuthenticated() ? authenticatedEvent : null,
        authenticatedError: isAuthenticated() ? authenticatedError : null
      };

      // Log custom page view event in console for debugging.
      console.info('Dispatching page view: ', pageView);

      // Dispatch custom page view event.
      window.dataLayer.push(pageView);
    }
  }

  useEffect(() => {
    // Ensure initial page has finished loading to get accurate user authentication status.
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      return () => window.removeEventListener('load', onPageLoad);
    }
  }, [location]);
}

export default usePageTracking;
